import {
  Button as ChakraButton,
  type ButtonProps,
  type ComponentWithAs,
} from '@chakra-ui/react';

const Button: ComponentWithAs<'button', ButtonProps> = ({ ...props }) => {
  return (
    <ChakraButton {...props}>
      {typeof props.children === 'string' ? (
        <span>{props.children}</span>
      ) : (
        props.children
      )}
    </ChakraButton>
  );
};
export default Button;
